import React from "react";

export function PageHeader({ eyebrow, title, description, right, testId }) {
    return (
        <header className="mb-10" data-testid={testId}>
            <div className="flex items-start justify-between gap-6 flex-wrap">
                <div className="max-w-2xl">
                    {eyebrow && <div className="label-mono mb-3">{eyebrow}</div>}
                    <h1 className="font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight text-foreground">
                        {title}
                    </h1>
                    {description && (
                        <p className="mt-4 text-muted-foreground max-w-xl">{description}</p>
                    )}
                </div>
                {right && <div className="flex items-center gap-2">{right}</div>}
            </div>
            <div className="rule mt-8" />
        </header>
    );
}

export function EmptyState({ title, hint, action, testId }) {
    return (
        <div className="paper rounded-sm border border-border p-10 text-center" data-testid={testId}>
            <div className="label-mono mb-3">Empty</div>
            <h3 className="font-serif text-2xl">{title}</h3>
            {hint && <p className="mt-2 text-sm text-muted-foreground">{hint}</p>}
            {action && <div className="mt-6">{action}</div>}
        </div>
    );
}

export function Chip({ children, tone = "default", className = "", ...rest }) {
    const cls = tone === "strong" ? "chip chip-strong" : tone === "red" ? "chip chip-red" : "chip";
    return (
        <span className={cls + " " + className} {...rest}>
            {children}
        </span>
    );
}
